export default __webpack_public_path__ + "static/media/marker.95fbc532.png";